module.exports = __webpack_public_path__ + "8a5356e9/img/share-icon.0f8a11b4.svg";